import { Button, Dialog, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ProjectConfig } from 'Global';
import { ApiRequest } from "GlobalFunctions";

export default function ParentProductsEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, parent_product_id, loadList, parent_product_name, setParentProduct } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues: any = {
    parent_product_id: parent_product_id ? parent_product_id : "null",
    parent_product_name: parent_product_name || "",
    parent_product_code: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (parent_product_id) {
      axios.get(`${ProjectConfig.api_url}/product_parents/details`, {
        params: { parent_product_id },
      })
      .then((response) => {
        setFormValues(response.data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
    } else {
      setFormValues({
        ...defaultValues,
        parent_product_name: parent_product_name || "",
      });
    }
  }, [parent_product_id]);

  useEffect(() => {
    if (parent_product_name && !parent_product_id) {
      setFormValues((prev: any) => ({ ...prev, parent_product_name: parent_product_name }));
    }
  }, [parent_product_name]);

  const handleInputChange = (e: { target: { name: any; value: any }; }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {
    if (!formValues.parent_product_name || !formValues.parent_product_code) {
      enqueueSnackbar("Nombre y código son requeridos", { variant: "error" });
      return;
    }

    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));

    await ApiRequest({
      url: "/product_parents/addedit",
      method: "post",
      headers: { ltkn: localStorage.getItem("ltkn") },
      body: body,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Producto padre guardado", { variant: "success" });
          setOpenEditor(false);
          if (loadList) loadList();
          if (setParentProduct) {
            setParentProduct({
              parent_product_name: formValues.parent_product_name,
              parent_product_id: response.parent_product_id,
            });
          }
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: '502px' }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Producto Padre</h2>
              <span className="h2_subtitle">{parent_product_id ? "Editar" : "Crear"}</span>
            </div>
          </div>

          <div className="input_group">
            <TextField
              id="parent_product_name"
              name="parent_product_name"
              label="Nombre"
              type="text"
              required
              fullWidth
              value={formValues.parent_product_name}
              onChange={handleInputChange}
            />

            <TextField
              id="parent_product_code"
              name="parent_product_code"
              label="Código"
              type="text"
              required
              fullWidth
              value={formValues.parent_product_code}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">Cancelar</Button>
            <Button onClick={handleSubmit} variant="contained">Guardar</Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
